import React from 'react';

const Bep20Icon = (props) => (
  <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_7765_13650)">
      <rect width="30" height="20" rx="2" fill="#F3BA2F"/>
      <path d="M12.3783 8.9227L15 6.301L17.623 8.92405L19.1486 7.39855L15 3.25L10.8528 7.3972L12.3783 8.9227ZM8.25 10L9.7755 8.4745L11.301 10L9.7755 11.5255L8.25 10ZM12.3783 11.0773L15 13.699L17.623 11.076L19.1486 12.6008L15 16.75L10.8528 12.6028L10.8508 12.6008L12.3783 11.0773ZM18.699 10L20.2245 8.4745L21.75 10L20.2245 11.5255L18.699 10ZM16.5471 9.99865H16.5485V10L15 11.5485L13.4536 10.0027L13.4509 10L13.4536 9.99797L13.7242 9.72663L13.8559 9.595L15 8.45155L16.5478 9.99932L16.5471 9.99865Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_7765_13650">
        <rect width="30" height="20" rx="2" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export default Bep20Icon;
